import { getLocalStorage } from '@/lib/localStorage'

export const leadsViewGuard = (to, from, next) => {
  const leadsViewSelected = getLocalStorage('leadsViewSelected')
  const defaultView = leadsViewSelected || 'pipeline'

  next({ name: 'leads-view', params: { view: defaultView }, query: to.query, replace: true })
}
